import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ColumnItem } from 'src/app/_models/column-item.model';
import {
  CdkDrag,
  CdkDragDrop,
  CdkDropList,
  moveItemInArray,
  transferArrayItem,
} from '@angular/cdk/drag-drop';
@Component({
  selector: 'DCO-table-configuration',
  templateUrl: './table-configuration.component.html',
  styleUrl: './table-configuration.component.css',
  standalone:false
})
export class TableConfigurationComponent {
  @Input() availableColumns: ColumnItem[] = [];
  @Input() selectedColumns: ColumnItem[] = [];
  @Input() visibleColumnIds: string[] = [];

  @Output() save = new EventEmitter<string[]>();
  @Output() close = new EventEmitter<void>();

  drop(event: CdkDragDrop<ColumnItem[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
  }
  


}
